import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Loads records for the dropdown after submitting a new record in the same
 * dropdown
 */
export const loadRecordsOnSubmit = store.effects.create((feature: Feature) =>
  feature.actions.submitRecord.success.observe().pipe(
    rxjs.map(action =>
      feature.actions.loadRecords.request.from(action).create({
        cacheFirst: false,
        entityId: action.data.request.entityId,
      }),
    ),
  ),
)
